/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
/* NPM Imports Start */
import React, { useState, useEffect, useMemo } from 'react';
import Popup from 'devextreme-react/popup';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'universal-cookie';
import SelectBox from 'devextreme-react/select-box';
import LoadPanel from 'devextreme-react/load-panel';
import _ from 'lodash';
/* NPM Imports End */

/* Project Imports Start */
import { useAuth } from '../../contexts/auth';
import {
  LoginAction,
  forgotpasswordAction,
  clearLoginUser,
} from '../../store/action/userAction';
import {
  regularExpression,
  callBackUrl,
  maxAge,
  n4000,
  superAdmin,
  appVersion,
} from '../../constant';
import {
  getConfiguration,
  storeLoginUrl,
} from '../../store/action/configurationAction';
import { ToasterMessage } from '../../components/sharedComponents/';
import logo from '../../assets/images/FieldPRO_Logo_Colour.svg';
import { ReactSVG } from 'react-svg';
import { CookiesBar } from '../../components/sharedComponents/cookiesAccept/cookiesAccept';
import SsoLogin from './SsoLogin';

/* Project Imports End */

/* CCS & Image imports Start */
import './Login.scss';
import '../../assets/fonts/onyx-icon-font/onyx.scss';
import secure from './comodo-secure-padlock.png';

/* CCS & Image imports End */

const Login = () => {
  const cookies = new Cookies();
  const history = useHistory();
  const dispatch = useDispatch();
  const { logIn, setCustomer } = useAuth();
  const [popup, setPopup] = useState(false);
  const [loginerror, setLoginerror] = useState(null);
  const [emailvalid, setEmailvalid] = useState(false);
  const [companyError, setCompanyError] = useState(false);
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [forgotemail, setForgotemail] = useState('');
  const [currentCompany, setCurrentCompany] = useState('');
  const loginres = useSelector(state => state);
  const [isAuthUser, setIsAuthUser] = useState(false);
  const [closeNoti, setCloseNoti] = useState(false);
  const [companyList, setcompanyList] = useState([]);
  const user = useSelector(state => state.configuration.user);

  useEffect(() => {
    if (document.cookie.includes('session')) {
      setCloseNoti(true);
      document.cookie = 'session' + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    } else {
      setCloseNoti(false);
    }
  }, []);
  useEffect(() => {
    if (loginres.user.loginUserDetails) {
      const companyList1 = loginres.user.loginUserDetails.customers
        ? loginres.user.loginUserDetails.customers
        : [];
      if (companyList1.length === 1) {
        setcompanyList(companyList1);
        cookies.set('token', `${companyList1[0].authToken}`, {
          path: '/',
          maxAge,
        });
        if (!user) {
          dispatch(getConfiguration());
        }
        if (companyList1[0].authLevel === superAdmin) {
          history.push('/CustomerList');
          logIn(loginres.user.loginUserDetails, companyList1[0].companyName);
          setIsAuthUser(true);
        } else {
          if (user) {
            if (cookies.get('linkNavigationUrl')) {
              dispatch(storeLoginUrl(true));
            }
            history.push(`/${user.replace('#', '')}`);
            logIn(loginres.user.loginUserDetails, companyList1[0].companyName);
            setIsAuthUser(true);
          }
        }
      } else {
        setcompanyList(companyList1);
        setIsAuthUser(true);
      }
    }
    if (loginres.user.errormsg != null) {
      setLoginerror(loginres.user.errormsg);
      setTimeout(() => {
        setLoginerror(null);
      }, n4000);
    }
    if (loginres.user.forgetsucessmsg !== null) {
      ToasterMessage(
        'custinfo',
        'You should receive an email shortly if you have entered a valid email address (please allow for upto 15 minutes ) with further instructions',
      );
    }
  }, [loginres, user]);
  useEffect(() => {
    if (loginres.user.loginUserDetails) {
      const companyList2 = loginres.user.loginUserDetails.customers
        ? loginres.user.loginUserDetails.customers
        : [];
      const newdata = companyList2.map(val => {
        if (val.authLevel === superAdmin) {
          val.companyName = `${val.companyName} (Super Admin)`;
          return val;
        }
        return val;
      });
      newdata.sort((a, b) => {
        const fa = a.companyName.toLowerCase(),
          fb = b.companyName.toLowerCase();
        if (fa < fb && a.authLevel === superAdmin) {
          return -1;
        }
        if (fa > fb && a.authLevel === superAdmin) {
          return 1;
        }
        return 0;
      });
      setcompanyList(newdata);
    }
  }, [loginres.user.loginUserDetails]);
  const loginUser = e => {
    if (document.cookie.includes('session')) {
      setCloseNoti(false);
      document.cookie = 'session' + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    } else {
      setCloseNoti(true);
    }
    setCloseNoti(false);
    e.preventDefault();
    const data = {
      email: userName,
      password,
    };
    dispatch(LoginAction('users/authenticate', data));
  };

  const companySelection = e => {
    e.preventDefault();
    const token = cookies.get('token', { path: '/' });
    const customer = currentCompany.companyName;
    if (token !== 'undefined') {
      setCompanyError(false);
      setCustomer();
      logIn(loginres.user.loginUserDetails, customer);
      if (cookies.get('linkNavigationUrl')) {
        dispatch(storeLoginUrl(true));
      }
      history.push(`/${user.replace('#', '')}`);
    } else {
      setCompanyError(true);
    }
  };

  const currentCompanyName = e => {
    setCompanyError(false);
    const currentCompany1 = _.find(companyList, function(item) {
      return item.companyName === e.value;
    });
    setCurrentCompany(currentCompany1);
    cookies.set('token', `${currentCompany1.authToken}`, {
      path: '/',
      maxAge,
    });
    dispatch(getConfiguration());
  };

  const inputchange = event => {
    if (event.target.type === 'password') {
      setPassword(event.target.value);
    } else if (event.target.name === 'forgotemail') {
      setForgotemail(event.target.value);
      setEmailvalid(!event.target.value);
    } else {
      setUserName(event.target.value);
    }
  };

  const forgotpass = () => {
    setPopup(true);
    setForgotemail('');
  };

  const hidePopup = () => {
    setPopup(false);
  };

  const submitforget = () => {
    const result = regularExpression.Email.test(
      String(forgotemail).toLowerCase(),
    );
    if (!forgotemail || !result) {
      setEmailvalid(true);
    }
    if (result) {
      setPopup(false);
      const data = {
        email: forgotemail,
        CallBackUrl: callBackUrl.url,
      };
      dispatch(forgotpasswordAction(`users/SendEmail`, data));
    }
  };
  const gotoLogin = () => {
    setIsAuthUser(false);
    setLoginerror(null);
    dispatch(clearLoginUser());
  };

  const ssl = data => {
    window.location.href =
      `${data}` === '1'
        ? 'https://www.instantssl.com/compare-tsl-ssl-certificates'
        : 'https://onyxinsight.com/our-story/';
  };

  const popupContent = () =>
    popup ? (
      <>
        <p>Enter your E-mail address</p>
        <input
          type="email"
          value={forgotemail}
          className="form-control"
          onChange={inputchange}
          name="forgotemail"
          data-cy="RP-EmailAddress-Textbox"
          required="required"
          autoComplete="off"></input>
        <div className={emailvalid ? 'emailValidation' : 'hide'}>
          <span> Please enter valid email.</span>
        </div>
        <div className="btnSubmit">
          <button
            className="btn btn-success"
            data-cy="RP-Submit-Button"
            onClick={submitforget}>
            Submit
          </button>
        </div>
      </>
    ) : (
      ''
    );

  return (
    <div className="d-flex align-items-center mx-auto">
      <CookiesBar />
      <Popup
        title="Reset Password"
        height="auto"
        width={500}
        data-cy="RP-ResetPassword-Popup"
        visible={popup}
        contentRender={popupContent}
        onHiding={hidePopup}></Popup>
      <LoadPanel
        visible={loginres.user.hasPendingLogin}
        shadingColor="rgba(0,0,0,0.4)"
      />
      <div id="formWrapper" className="formWrapper">
        <div className="loginContainer">
          <div id="form" className="form">
            <div id="sendlogin" className="sendlogin">
              <ReactSVG src={logo} />
            </div>
            {isAuthUser === true ? (
              <form>
                <div style={{ paddingTop: '25px' }}>
                  <div className="form-item">
                    <strong>Select Company Name</strong>
                    <div>
                      <SelectBox
                        dropDownOptions={{ height: 200 }}
                        stylingMode={'outlined'}
                        dataSource={companyList}
                        displayExpr="companyName"
                        elementAttr={{ 'data-cy': 'SC-SelectCompany-Dropdown' }}
                        valueExpr="companyName"
                        onValueChanged={currentCompanyName}
                        placeholder="Select company..."
                        defaultValue={companyList[0]}
                        searchEnabled={true}
                      />
                    </div>
                  </div>
                  {companyError && (
                    <p className="error">Please select company</p>
                  )}
                  <div className="form-item login">
                    <button
                      type="submit"
                      className="Loginbutton"
                      data-cy="SC-ProceedLogin-Button"
                      onClick={companySelection}>
                      Proceed Login
                    </button>
                  </div>
                  <div className="form-item linkCenter">
                    <span
                      className="forgotpass"
                      data-cy="SC-BackLogin-Link"
                      onClick={gotoLogin}>
                      Back to Login?
                    </span>
                  </div>
                </div>
              </form>
            ) : (
              <form className="inner-form">
                <div className="form-item">
                  <strong>Email Address</strong>
                  <div className="txtBoxWithIcon">
                    <i className="icon onyx icon-email"></i>
                    <input
                      type="name"
                      data-cy="LP-EmailAddress-Textbox"
                      value={userName}
                      onChange={inputchange}
                      name="email"
                      id="emailid"
                      className="form-control form-style txtIcon"
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div className="form-item">
                  <strong>Password</strong>
                  <div className="txtBoxWithIcon">
                    <i className="icon onyx icon-key"></i>
                    <input
                      data-cy="LP-Password-Textbox"
                      type="password"
                      onChange={inputchange}
                      name="password"
                      id="password"
                      className="form-control form-style txtIcon"
                    />
                  </div>
                </div>
                <div
                  id="warning"
                  className={loginerror !== null ? 'warning' : 'hide'}>
                  <p>Authentication has failed: {loginerror}</p>
                </div>
                <div className="form-item login">
                  <button
                    type="submit"
                    data-cy="LP-Login-Button"
                    className="Loginbutton"
                    onClick={loginUser}>
                    Login
                  </button>
                </div>
                <div className="form-item linkCenter">
                  <span
                    className="forgotpass"
                    data-cy="LP-ForgotPassword-Link"
                    onClick={forgotpass}>
                    Forgot Password?
                  </span>
                </div>
                <SsoLogin />
              </form>
            )}
          </div>
          <div className="linkbutton">
            <button
              className="btn btn-warning btnCustom"
              data-cy="LP-FindOutMore-Button"
              onClick={() => ssl('2')}>
              Find Out More
            </button>
            <div
              onClick={() => ssl('1')}
              data-cy="LP-SSL-Link"
              className="link">
              <img className="imgSSL" src={secure}></img>
              <span style={{ cursor: 'pointer' }}>
                <strong>SSL</strong>
              </span>
            </div>
          </div>
        </div>
        <div className="disclaimer-container">
          <p>
            ONYX Insight fieldPRO {appVersion} - © {new Date().getFullYear()}{' '}
            Insight Analytics Solutions Limited.
          </p>
        </div>
      </div>
      {closeNoti && (
        <div className="customPopup">
          <span className="closeIcon"></span> Session Expired
        </div>
      )}
    </div>
  );
};

Login.displayName = 'Login';
export default Login;
